import { Reducer } from '@reduxjs/toolkit'

import IAbsenceState from './IAbsenceState'
import { initialState } from './initialState'
import {
  TActionTypes,
  ADD_ABSENCE_SUCCESS,
  DELETE_ABSENCE_SUCCESS,
  GET_ABSENCES,
  GET_ABSENCES_FAILURE,
  GET_ABSENCES_SUCCESS,
  UNDO_DELETE_ABSENCE_SUCCESS,
  UPDATE_ABSENCE_SUCCESS,
} from './TActionTypes'

export const absenceReducer: Reducer<IAbsenceState, TActionTypes> = (
  state = initialState,
  action,
): IAbsenceState => {
  switch (action.type) {
    case GET_ABSENCES:
      return {
        ...state,
        isLoading: true,
      }
    case GET_ABSENCES_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: false,
        list: action.payload.absences,
      }
    case GET_ABSENCES_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: true,
      }
    case DELETE_ABSENCE_SUCCESS:
      const absenceIndex = state.list.findIndex(
        absenceState => action.payload.absence.id === absenceState.id,
      )

      if (-1 === absenceIndex) {
        return state
      }

      const absence = action.payload.absence
      absence.isDeleted = true

      return {
        ...state,
        list: [
          ...state.list.slice(0, absenceIndex),
          absence,
          ...state.list.slice(absenceIndex + 1),
        ],
      }
    case UNDO_DELETE_ABSENCE_SUCCESS:
      const undoDeleteAbsenceIndex = state.list.findIndex(
        absenceState => action.payload.deletedAbsence.id === absenceState.id,
      )

      const newAbsence = action.payload.absence
      newAbsence.isDeleted = false

      if (-1 < undoDeleteAbsenceIndex) {
        return {
          ...state,
          list: [
            ...state.list.slice(0, undoDeleteAbsenceIndex),
            ...state.list.slice(undoDeleteAbsenceIndex + 1),
            newAbsence,
          ],
        }
      }
      return {
        ...state,
        list: [...state.list, newAbsence],
      }
    case UPDATE_ABSENCE_SUCCESS:
      const updatedAbsenceIndex = state.list.findIndex(
        absenceState => action.payload.absence.id === absenceState.id,
      )

      if (-1 === updatedAbsenceIndex) {
        return state
      }

      return {
        ...state,
        list: [
          ...state.list.slice(0, updatedAbsenceIndex),
          action.payload.absence,
          ...state.list.slice(updatedAbsenceIndex + 1),
        ],
      }
    case ADD_ABSENCE_SUCCESS:
      return {
        ...state,
        list: [...state.list, action.payload.absence],
      }
    default:
      return state
  }
}
